/*
 * File: card-group.ts
 * File Created: 2023-12-27 04:23:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:30:06
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseComponent } from "@root/components/base-classes";

@Component
export default class CardGroup extends BaseComponent {}
